import { render, staticRenderFns } from "./job_detail.vue?vue&type=template&id=2cc43b5f&scoped=true"
import script from "./job_detail.vue?vue&type=script&lang=js"
export * from "./job_detail.vue?vue&type=script&lang=js"
import style0 from "./job_detail.vue?vue&type=style&index=0&id=2cc43b5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc43b5f",
  null
  
)

export default component.exports